
import { defineComponent, Ref, nextTick } from 'vue'
import { ref } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import EmojiPicker from '@/components/Forms/EmojiPicker.vue'
import { PostContentConstraints } from '@/validation/postValidator'
import PostTextCounter from '@/components/Forms/PostTextCounter.vue'
import useEmojiShortcuts from '@/composables/emojis/emojiShortcuts'

export default defineComponent({
  name: 'PostText',
  components: { PostTextCounter, EmojiPicker, AIcon, AButton },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    savingPost: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      input: '',
      CONTENT_MAX_LENGTH: PostContentConstraints.MAX_LENGTH,
      lastPos: 0,
      showEmojis: false,
    }
  },
  watch: {
    modelValue() {
      this.input = this.modelValue
    },
  },
  methods: {
    handleInput(lastChar: InputEvent) {
      this.resize()
      this.lastPos = 0
      let cursorStart: number | undefined

      const textarea: any = this.$refs.postContentRef
      if (textarea !== 'undefined') {
        cursorStart = textarea.selectionStart - 1

        this.input = this.replaceEmoji(
          lastChar.data ?? '',
          cursorStart,
          this.input
        )
      }

      this.$emit('update:modelValue', this.input)
      nextTick(() => {
        if (cursorStart) {
          textarea.setSelectionRange(cursorStart + 1, cursorStart + 1)
        }
      })
    },
    onFocusIn() {
      this.lastPos = 0
    },
    resize() {
      const textareaEl: any = this.$refs.postContentRef

      if (typeof textareaEl === 'undefined') {
        return false
      }

      textareaEl.style.height = 'auto'
      textareaEl.style.height = `${textareaEl.scrollHeight}px`
    },
    insertEmoji(emoji: any) {
      if (typeof this.input !== 'undefined') {
        const textarea: any = this.$refs.postContentRef

        if (typeof textarea === 'undefined') {
          return false
        }

        let cursorStart: number = textarea.selectionStart
        let cursorEnd: number = textarea.selectionEnd

        if (this.lastPos > 0) {
          cursorStart = cursorEnd = this.lastPos
        }

        const beforeText = this.input.slice(0, cursorStart)
        const afterText = this.input.slice(cursorEnd)

        this.input = beforeText + emoji + afterText
        textarea.setSelectionRange(beforeText, beforeText)

        this.lastPos = cursorStart + 2
        this.$emit('update:modelValue', this.input)
      }
    },
  },
  mounted() {
    this.input = this.modelValue
  },
  updated() {
    this.resize()
  },
  setup() {
    const emojiContentRef: Ref<Node | undefined> = ref()
    const postContentRef: Ref<Node | undefined> = ref()

    return {
      postContentRef,
      emojiContentRef,
      ...useEmojiShortcuts(),
    }
  },
})
